import React from 'react';
import AdvisorRoute from './advisor/';
import CompanyRoute from './company/';
import ModuleRoute from './modules/';
import MagicLinkRoute from './magic/';
import SchedulerRoute from './scheduler/';
import UserRoute from './user/';
import OfficeHoursRoute from './officehours/';
import OfficeHoursV2Route from './officehours-v2/';
import StudentReportRoute from './student-report/';
import ProgressReportRoute from './progress-report/';
import RecordingsRoute from './recordings/';
import AssessmentRoute from './assessment/';
import SignupRoute from './signup/';
import SigninRoute from './signin/';
import Route404 from './404/';

export const createRoutes = store => ({
  path: '/',
  component: props => props.children,
  indexRoute: ({
    component: props => {
      console.log(props);
      if (props.location.pathname === "/") {
        window.location = "https://paragonone.com";
      }

      return (
        <div></div>
      )
    },
  }),
  childRoutes: [
    AdvisorRoute(store),
    CompanyRoute(store),
    ModuleRoute(store),
    MagicLinkRoute(store),
    SchedulerRoute(store),
    UserRoute(store),
    OfficeHoursRoute(store),
    OfficeHoursV2Route(store),
    StudentReportRoute(store),
    ProgressReportRoute(store),
    RecordingsRoute(store),
    AssessmentRoute(store),
    SignupRoute(store),
    SigninRoute(store),
    Route404(store), // Must be last
  ],
});

export default createRoutes;



// WEBPACK FOOTER //
// ./src/routes/index.js